import React from 'react';
import { CandidateBadges } from '@axiom/ui';
import type {
  AfcCandidateSearch,
  Candidate,
  LimitedCandidate,
  SavedCandidate,
} from '@axiom/validation';

export type TalentBadgesProps = {
  candidate:
    | Candidate
    | AfcCandidateSearch
    | SavedCandidate['candidate']
    | LimitedCandidate;
};

export const TalentBadges = ({ candidate }: TalentBadgesProps) => {
  return (
    <CandidateBadges
      badges={[
        ...(candidate.availabilityStatus
          ? [
              candidate.availabilityStatus === 'AvailableNow' &&
              candidate.weeklyAvailability
                ? {
                    key: candidate.availabilityStatus,
                    customText: `Available Now - ${candidate.weeklyAvailability} hrs`,
                  }
                : candidate.availabilityStatus,
            ]
          : []),
        ...candidate.badges,
      ]}
    />
  );
};
